<template>
  <div class="contact-page">
    <PageTitle
      title="Let's Talk."
      subtitle="If you have questions, concerns, or feedback, reach out to our support team and we'll get back to you."
      backgroundClass="-banner is-dark -banner-13"
    />
    <section class="section">
      <div class="container">
        <ContactForm />
      </div>
    </section>
    <JoinBetaProgram />
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import ContactForm from "@/components/library/ContactForm.vue";
import JoinBetaProgram from "@/components/library/JoinBetaProgram.vue";

export default {
  name: "contactPage",
  components: {
    PageTitle,
    ContactForm,
    JoinBetaProgram
  }
};
</script>

<style scoped lang="scss"></style>
